import type {User} from '../types';

export const getDummyUser = (userId: string): User => ({
  id: userId,
  name: '',
  email: '',
  picture: undefined,
});
